import { useAuth } from "./AuthProvider";

export function Authorized({ children }: React.PropsWithChildren<{}>) {
  const { user } = useAuth()

  return <>{ user && children }</>
}
